import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'


interface ModalDeleteConfigShippingServiceProps extends ModalEditComponentProps { }

const ModalDeleteConfigShippingService: React.FC<ModalDeleteConfigShippingServiceProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/config/shipping/shippingCompany/service/deleteShippingService',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteShippingService', '¿Seguro quieres eliminar este servicio de este transportista?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteConfigShippingService